import type { DeviceManagerDeps } from '@yandex-360/telemost-sdk/device-manager';

import type { GoloomSDK } from '../../../goloom-sdk/goloom-sdk';
import { GoloomCallSession } from './goloom-call-session';
import { GoloomDeviceErrorMapper } from './goloom-device-error-mapper';
import { GoloomMediaProcessing } from './goloom-media-processing';
import { GoloomPreviewSession } from './goloom-preview-session';

export type GoloomMediaBackend = DeviceManagerDeps & {
    preview: GoloomPreviewSession;
    call: GoloomCallSession;
};

export function createGoloomMediaBackend(goloomSdk: GoloomSDK): GoloomMediaBackend {
    const preview = new GoloomPreviewSession();

    return {
        preview,
        call: new GoloomCallSession(goloomSdk),
        mediaProcessing: new GoloomMediaProcessing(),
        errors: new GoloomDeviceErrorMapper(),
    };
}
